export const lazyLoadVideo = () => {
  const videoElements = document.querySelectorAll("video[data-lazy-video]");
  if (videoElements.length === 0) {
    return;
  }

  const loadVideo = (videoElement) => {
    const sources = videoElement.querySelectorAll("source");
    sources.forEach((source) => {
      const dataSrc = source.getAttribute("data-src");
      if (dataSrc) {
        source.setAttribute("src", dataSrc);
      }
    });

    videoElement.load();
    videoElement.play();
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const videoElement = entry.target;
        loadVideo(videoElement);
        observer.unobserve(videoElement);
      }
    });
  });

  videoElements.forEach((video) => observer.observe(video));
};
